"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomRoomFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomRoomFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.4c0-.84 0-1.26.163-1.58A1.5 1.5 0 0 1 2.82.163C3.139 0 3.559 0 4.4 0h7.2c.84 0 1.26 0 1.581.164a1.5 1.5 0 0 1 .655.655C14 1.14 14 1.56 14 2.4v3.2c0 .84 0 1.26-.164 1.581a1.5 1.5 0 0 1-.655.656C12.861 8 12.441 8 11.6 8H4.4c-.84 0-1.26 0-1.581-.163a1.5 1.5 0 0 1-.656-.656C2 6.861 2 6.441 2 5.601V2.4Zm6 1.707A1.429 1.429 0 1 0 8 1.25a1.429 1.429 0 0 0 0 2.857Zm0 .503c-1.429 0-2.5.64-2.5 1.429 0 .394.37.714.714.714h3.572c.345 0 .714-.32.714-.714 0-.79-1.071-1.429-2.5-1.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.857A1.429 1.429 0 1 0 2.5 9a1.429 1.429 0 0 0 0 2.857ZM9.43 11.719a1.429 1.429 0 1 1-2.858 0 1.429 1.429 0 0 1 2.857 0ZM6.214 16.004c-.345 0-.714-.32-.714-.714 0-.789 1.071-1.428 2.5-1.428s2.5.639 2.5 1.428c0 .395-.37.714-.714.714H6.214ZM0 14c0-.789 1.071-1.428 2.5-1.428S5 13.212 5 14c0 .395-.37.714-.714.714H.714C.37 14.714 0 14.394 0 14ZM13.5 11.857A1.429 1.429 0 1 0 13.5 9a1.429 1.429 0 0 0 0 2.857ZM11 14c0-.789 1.071-1.428 2.5-1.428S16 13.212 16 14c0 .395-.37.714-.714.714h-3.572c-.345 0-.714-.32-.714-.714Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomRoomFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomRoomFill;
exports["default"] = _default;